import Vue from 'vue'
import Vuex from 'vuex'
import { setLocale } from '@/i18n'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: JSON.parse(localStorage.getItem('opcardx_user')) || null,
    token: localStorage.getItem('opcardx_token') || null,
    locale: localStorage.getItem('opcardx_lang') || 'en',
    collection: [],
    lastScanResults: JSON.parse(localStorage.getItem('opcardx_scan_results') || '[]'),
    lastScanState: localStorage.getItem('opcardx_scan_state') || 'idle'
  },

  getters: {
    isLoggedIn: state => !!state.token && !!state.user,
    currentUser: state => state.user,
    token: state => state.token,
    collection: state => state.collection,
    lastScanResults: state => state.lastScanResults,
    lastScanState: state => state.lastScanState,
    locale: state => state.locale
  },

  mutations: {
    SET_USER (state, user) {
      state.user = user
      if (user) {
        localStorage.setItem('opcardx_user', JSON.stringify(user))
      } else {
        localStorage.removeItem('opcardx_user')
      }
    },

    SET_TOKEN (state, token) {
      state.token = token
      if (token) {
        localStorage.setItem('opcardx_token', token)
        localStorage.setItem('opcardx_token_time', Date.now().toString())
      } else {
        localStorage.removeItem('opcardx_token')
      }
    },

    CLEAR_AUTH (state) {
      state.user = null
      state.token = null
      state.collection = []
      state.lastScanResults = []
      state.lastScanState = 'idle'
      localStorage.removeItem('opcardx_token')
      localStorage.removeItem('opcardx_user')
      localStorage.removeItem('opcardx_scan_results')
      localStorage.removeItem('opcardx_scan_state')
    },

    SET_LOCALE (state, lang) {
      state.locale = lang
      setLocale(lang)
    },

    SET_COLLECTION (state, list) {
      state.collection = list
    },

    UPDATE_CARD_OWNED (state, { cardId, owned }) {
      const card = state.collection.find(c => c.id === cardId)
      if (card) {
        card.owned = owned
        if (owned <= 0) {
          state.collection = state.collection.filter(c => c.id !== cardId)
        }
      } else if (owned > 0) {
        state.collection.push({ id: cardId, owned })
      }
    },

    SET_SCAN_RESULTS (state, { results, scanState }) {
      state.lastScanResults = results
      state.lastScanState = scanState
      localStorage.setItem('opcardx_scan_results', JSON.stringify(results))
      localStorage.setItem('opcardx_scan_state', scanState)
    },
  },

  actions: {
    login ({ commit }, { user, token }) {
      commit('SET_USER', user)
      commit('SET_TOKEN', token)
    },

    logout ({ commit }) {
      commit('CLEAR_AUTH')
    },

    switchLocale ({ commit }, lang) {
      commit('SET_LOCALE', lang)
    },

    updateCardOwned ({ commit }, payload) {
      commit('UPDATE_CARD_OWNED', payload)
    },

    saveScanResults ({ commit }, { results, scanState }) {
      commit('SET_SCAN_RESULTS', { results, scanState })
    }
  }
})